import React from 'react'
import { Helmet } from 'react-helmet-async'

const DefaultMeta: React.FC = () => (
  <Helmet defaultTitle="mprolab">
    <html lang="en" />
    <title>mprolab</title>
    <link rel="icon" href="/mprolab-favicon.svg" type="image/svg+xml" />
    <link rel="icon" href="/mprolab-icon-32.png" type="image/png" sizes="32x32" />
    <link rel="apple-touch-icon" href="/mprolab-apple-touch-icon.png" />
    <meta property="og:type" content="website" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta charSet="utf-8" />
    <meta
      name="title"
      content="MPRO Lab: Empowering the DAGO Community & Licenses Providers | MPRO"
    />
    <meta
      name="description"
      content="MPRO Lab — licenses, index nodes, and MPRO rewards for providers and the DAGO community."
    />
    <meta name="keywords" content="" />
    <meta property="og:title" content="MPRO Lab: Empowering the DAGO Community & Licenses Providers | MPRO" />
    <meta
      property="og:description"
      content="MPRO Lab — licenses, index nodes, and MPRO rewards for providers and the DAGO community."
    />
    <meta property="og:image" content="https://mprolab.io/mprolab-og.png" />
    <meta property="og:image:url" content="https://mprolab.io/mprolab-og.png" />
    <meta name="twitter:title" content="MPRO Lab: Empowering the DAGO Community & Licenses Providers | MPRO" />
    <meta
      name="twitter:description"
      content="MPRO Lab — licenses, index nodes, and MPRO rewards for providers and the DAGO community."
    />
    <meta name="twitter:image" content="https://mprolab.io/mprolab-og.png" />
    <meta property="og:image:type" content="image/png" />
    <meta name="twitter:card" content="summary_large_image" />
  </Helmet>
)

export default DefaultMeta
